<template>
  <Card class="box-card">
    <Tabs v-model="menuCurrentName" @on-click="changeMenuCurrent" v-if="menuList.length">
      <TabPane :name="item.name" :label="item.label" v-for="(item, index) in menuList" :key="index" class="tabs-style">
      </TabPane>
    </Tabs>
    <Tabs type="card" v-model="subMenuCurrentName" @on-click="changeSubMenuCurrent" :animated="false">
      <TabPane label="帮扶说明" name="0">
        <info @changeSubMenu="changeSubMenu" :helpPlanDetail="helpPlanDetail1" @helpPlanDetail="helpPlanDetail" ref="infos"/>
      </TabPane>
      <TabPane label="帮扶项目" name="1" :disabled="!helpPlanDetail1.help_company || (helpPlanDetail1.help_company && helpPlanDetail1.help_company.status !==1)">
        <project :planId="menuCurrentName" ref="proj" />
      </TabPane>
      <TabPane label="帮扶积分" name="2" :disabled="!helpPlanDetail1.help_company || (helpPlanDetail1.help_company && helpPlanDetail1.help_company.status !==1)">
        <score :planId="menuCurrentName" ref="scores" />
      </TabPane>
      <TabPane label="补贴申报" name="3" :disabled="!helpPlanDetail1.help_company || (helpPlanDetail1.help_company && helpPlanDetail1.help_company.status!==1)">
        <subsidy :planId="menuCurrentName" ref="subsidys" />
      </TabPane>
    </Tabs>
  </Card>
</template>

<script>
import info from './info.vue';
import project from './project.vue';
import score from './score.vue';
import subsidy from './subsidy.vue';
export default {
  name: 'HelpManage',
  components: { info, project, score, subsidy },
  data() {
    return {
      menuCurrentName: '1',
      subMenuCurrentName: '0',
      menuList: [],
      helpPlanDetail1: {}
    };
  },
  created() {
    this.helpPlan();
  },
  watch: {
    subMenuCurrentName: {
      handler(newVal, oldVal) {
        if(newVal == "1")
        this.$refs.proj.getList()
      },
      deep: true
    }
  },
  beforeRouteEnter(to, from, next) {
    // 这里的 'from' 是上一个路由对象
    next(vm => {
      vm.previousRoute = from;
      if (from.name == "HelpProjectEdit" || from.name == "HelpProjectDetail") {
      vm.subMenuCurrentName = "1"
      vm.$nextTick(() => {
        window.scrollTo({
          top: 0,
          behavior: 'smooth', // 平滑滚动
        });
        const scrollable = document.querySelector('.main-layout');
        if (scrollable) {
          scrollable.scrollTop = 0; // 滚动到顶部
        }
      });

    }
    });
    
  },
  mounted() {
    
  },
  methods: {
    helpPlan() {
      this.$axios
        .request({
          url: 'front/v1/help-plan',
          method: 'get',
          params: { pageIndex: 1, pageSize: 100 }
        })
        .then(res => {
          let data = res.data.list || [];
          data.map(item => {
            this.menuList.push({ label: item.name, name: item.id + '' });
          });
          if (data.length) {
            this.menuCurrentName = this.menuList[0].name;
            this.helpPlanDetail();
          }
        });
    },
    helpPlanDetail() {
      this.$axios
        .request({
          url: 'front/v1/help-plan/company/' + this.menuCurrentName,
          method: 'get'
        })
        .then(res => {
          this.helpPlanDetail1 = res.data;
        });
    },
    changeMenuCurrent(e) {
      this.helpPlanDetail();
      if (this.subMenuCurrentName === '0') {
        this.$refs.infos.setUpload();
      }
    },
    changeSubMenu(e) {
      this.subMenuCurrentName = e;
    },
    changeSubMenuCurrent(e, index) {
      if(!this.helpPlanDetail1.help_company || (this.helpPlanDetail1.help_company && this.helpPlanDetail1.help_company.status !==1)){
        this.$Message.error('请先加入帮扶计划')
        this.subMenuCurrentName = '0';
        return false;
      }

      if (e === '0') {
        this.$refs.infos.setUpload();
      }else if (e === '3') {
        this.$refs.subsidys.getTotal();
        this.$refs.subsidys.helpDeclare();
      } else if (e === '2') {
        this.$refs.scores.getTotal();
        this.$refs.scores.getScore()
      }
    },
    submitSubsidy() {
      this.$subsidyModal.info({
        title: '帮扶积分不足',
        content: `当前帮扶积分：0`,
        okText: '知道了'
      });
    },
    changesubsidyModal(status = false) {
      this.subsidyModal = status;
    }
  }
};
</script>
<style lang="less" scoped>
::v-deep .tabs-style .ivu-tabs-bar {
  margin-bottom: 0;
}
</style>
